import React, { useState } from 'react';
import classnames from 'classnames';
import rupee_icon from '../../../images/icons/rupee_icon.svg';
import CommonInput from './CommonInput';
import './CommonInput.css';

function CommonRupeeIcon() {
  return (
    <>
      <img src={rupee_icon} alt="" />
    </>
  );
}

function CommonInputWithIcon({
  name,
  max,
  min,
  maxLength,
  id,
  type = 'text',
  legendName,
  value,
  onChange,
  onBlur,
  onKeyUp,
  onKeyDown,
  onKeyPress,
  disabled,
  error,
  errorMsg,
  touched,
  stylesContainer = {},
  legendStyle = { paddingLeft: '20px' },
  inputStyle = {
    paddingLeft: '40px',
    letterSpacing: '1px'
  },
  iconStyle = { marginTop: '17px' },
  onBlurStyle = { paddingLeft: '20px' },
  iconprops = <CommonRupeeIcon />,
  rupeeIcon = true
}) {
  return (
    <div className="grid_input_container relative mb-1">
      {rupeeIcon ? (
        <div
          style={iconStyle}
          className="absolute text-grey-50 z-10  pt-px text-md ml-4"
        >
          {iconprops}
        </div>
      ) : null}
      <div>
        <CommonInput
          type={type}
          name={name}
          onChange={onChange}
          onBlur={onBlur}
          value={value}
          id={id}
          stylesContainer={stylesContainer}
          inputStyle={inputStyle}
          onBlurStyle={onBlurStyle}
          legendStyle={legendStyle}
          legendName={legendName}
          errorMsg={errorMsg}
          error={error}
          touched={touched}
          disabled={disabled}
        />
      </div>
    </div>
  );
}

export default CommonInputWithIcon;
